import * as React from "react";
import { Link } from "azure-devops-ui/Link";

export default class LinkExample extends React.Component {
    public render(): JSX.Element {
        return <Link href="https://www.microsoft.com/">Microsoft home page</Link>;
    }
}
